import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { TextField, Typography } from '@material-ui/core'

import {
  Button,
  DialogConfirm,
} from 'ui/components'

import {
  patchPlan,
} from 'services/apiMotorBgc'

import styles from './styles'

export default ({ docType, plan, onSubmit = null }) => {
  const classes = styles()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [planName, setPlanName] = useState(plan.name || '')
  const [description, setDescription] = useState(plan.description || '')

  const planNameValid = () => {
    return planName.length >= 3 && planName.length <= 100
  }

  const descriptionValid = () => {
    return description.length <= 200
  }

  const formValid = () => {
    if (!planNameValid()) return false
    if (!descriptionValid()) return false

    return true
  }

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const handleCancel = () => {
    setModalOpen(false)
  }

  const handlePlanEdit = async () => {
    setLoading(true)

    try {
      await patchPlan(
        apiKey,
        userId,
        docType,
        plan.plan_id,
        {
          name: planName,
          description: description || null,
        },
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao editar plano'
      toast.error(messageError)
      setLoading(false)
      return
    }

    setLoading(false)
    setModalOpen(false)
    toast.success('Plano editado com sucesso!')

    if (_.isFunction(onSubmit)) onSubmit()
  }

  const renderPlanNameInput = () => {
    return (
      <TextField
        id="name"
        label="Nome do plano"
        type="text"
        value={planName}
        onChange={(e) => setPlanName(e.target.value)}
        required={true}
        autoCapitalize="off"
        autoCorrect="off"
        error={!planNameValid()}
        inputProps={{
          minLength: 3,
          maxLength: 100,
        }}
      />
    )
  }

  const renderDescriptionInput = () => {
    return (
      <TextField
        id="description"
        label="Descrição do plano"
        type="text"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required={false}
        autoCapitalize="off"
        autoCorrect="off"
        error={!descriptionValid()}
        fullWidth={true}
        multiline={true}
        minRows={3}
        size="medium"
        inputProps={{
          minLength: 3,
          maxLength: 200,
        }}
      />
    )
  }

  const renderPlanName = () => {
    return (
      <Typography>
        <strong>Nome:</strong>
        {' '}
        <span>{plan.name}</span>
      </Typography>
    )
  }

  const renderForm = () => {
    return (
      <form className={classes.formContainer}>
        {renderPlanNameInput()}
        {renderDescriptionInput()}
      </form>
    )
  }

  const renderContent = () => {
    if (_.isEmpty(plan)) return null

    return (
      <div className={classes.contentContainer}>
        {renderPlanName()}
        {renderForm()}
      </div>
    )
  }

  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        onClick={handleToggleModal}
      >
        Editar
      </Button>

      <DialogConfirm
        title="Editar Plano"
        open={modalOpen}
        onCancel={handleCancel}
        onConfirm={handlePlanEdit}
        content={renderContent()}
        btnConfirmDisabled={loading || !formValid()}
        btnConfirmText="Editar"
        btnCancelText="Cancelar"
      />
    </div>
  )
}
